import React, { useRef } from 'react';
import Modal from '../shared/Modal';
import useMessageSettings from '../../hooks/useMessageSettings';
import { getPriorityInfo } from '../../utils/messageUtils';
import { resolveDateTags } from '../../utils/dateCommandUtils';

const PreviewTemplateModal = ({ isOpen, onClose, template }) => {
    const closeRef = useRef(null);
    const { messageTypes } = useMessageSettings();

    if (!template) return null;

    // Trouver la couleur correspondant au type du template
    const typeColor = messageTypes.find(t => t.name === template.type)?.color || '#3b82f6';
    
    const priorityInfo = getPriorityInfo(template.priority || 'moyenne');

    const modalActions = (
        <button
            ref={closeRef}
            onClick={onClose}
            className="flex-1 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-bold py-2 px-4 rounded hover:bg-gray-400 dark:hover:bg-gray-600"
        >
            Fermer
        </button>
    );

    return (
        <Modal 
            open={isOpen} 
            onClose={onClose} 
            title={`Aperçu : ${template.name}`}
            actions={modalActions}
            initialFocusRef={closeRef}
        >
            <div>
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Titre
                    </label>
                    <p className="text-gray-900 dark:text-white font-semibold">
                        {template.title}
                    </p>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Contenu
                    </label>
                    <div 
                        className="prose prose-sm dark:prose-invert max-w-none p-4 bg-gray-50 dark:bg-gray-900 rounded border dark:border-gray-700"
                        dangerouslySetInnerHTML={{ __html: resolveDateTags(template.content) }}
                    />
                </div>

                <div className="grid grid-cols-3 gap-4">
                    <div className="flex flex-col items-center">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Type
                        </label>
                        <span 
                            className="w-full text-center px-3 py-1 rounded text-white font-medium"
                            style={{ backgroundColor: typeColor }}
                        >
                            {template.type}
                        </span>
                    </div>
                    <div className="flex flex-col items-center">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Rôle
                        </label>
                        <span className="w-full text-center px-3 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded">
                            {template.role}
                        </span>
                    </div>
                    <div className="flex flex-col items-center">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Priorité
                        </label>
                        <span 
                            className={`w-full text-center inline-flex items-center justify-center gap-1 px-3 py-1 rounded font-medium border ${priorityInfo.bgColor} ${priorityInfo.textColor} ${priorityInfo.borderColor}`}
                            title={priorityInfo.title}
                        >
                            <span className="text-sm font-bold">{priorityInfo.icon}</span>
                            {priorityInfo.label}
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default PreviewTemplateModal;
